import { memo } from 'react';
import classNames from 'classnames';
import ProductDiscountsInfo from 'components/ProductDiscountsInfo';
import toDollars from 'utils/to-dollars';
import styles from './ProductPrice.module.scss';

function ProductPrice({
  availableDiscounts = [],
  discountedCents,
  fullPriceCents,
  groupedDiscountsContent,
  menu,
  priceLabel = 'Price',
}) {
  const displayCents = discountedCents || fullPriceCents;
  const isDiscounted = fullPriceCents !== displayCents;
  const price = toDollars(displayCents).toFixed(2);
  const fullPrice = isDiscounted && toDollars(fullPriceCents).toFixed(2);
  const menuText = menu === 'medical' ? 'Medical' : 'Recreational';
  const label = `${menuText} ${priceLabel}`;
  const title = isDiscounted ? `${label} - Discount Applied` : label;
  return (
    <div className="flex flex-column mb-15">
      <h4
        className="font-roboto fw-600 fs-6 text-uppercase text-grey-darker"
        data-value="product-price-message"
      >
        {title}
      </h4>
      <div className="d-flex flex-row font-sofia fs-12 fs-sm-14 fs-xxl-14 fw-700">
        <span className="text-primary" data-value="product-price">
          {`$${price}`}
        </span>
        {fullPrice ? (
          <span
            className={classNames(
              `fs-8 fs-sm-10 fw-500 ms-4 mt-1 text-muted ${styles.full_price}`,
              styles.strikethrough_dollars
            )}
            data-value="product-full-price"
            aria-label={`Price was $${fullPrice}`}
          >{`$${fullPrice}`}</span>
        ) : null}
      </div>
      <ProductDiscountsInfo
        discounts={availableDiscounts}
        groupedDiscountsContent={groupedDiscountsContent}
        mainSpanCustomStyling="font-sofia fs-6 fs-md-7 fw-700"
        showMoreCustomStyling="font-sofia fs-6 fs-md-7 fw-700"
      />
    </div>
  );
}

export default memo(ProductPrice);
